import { render } from "./StreakComponent.vue?vue&type=template&id=07c8c763&scoped=true&ts=true"
import script from "./StreakComponent.vue?vue&type=script&lang=ts"
export * from "./StreakComponent.vue?vue&type=script&lang=ts"

import "./StreakComponent.vue?vue&type=style&index=0&id=07c8c763&lang=scss"
import "./StreakComponent.vue?vue&type=style&index=1&id=07c8c763&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c8c763"]])

export default __exports__